import axios_, { AxiosError } from "axios";
import { WebLogger } from "./logger";
import { toast } from "react-toastify";
import { isProductionMode, LocalStorageKeys } from "./utils";
import { strings } from "../intl/fa";
import axiosRetry from "axios-retry";

const useStagingUrl =
  window.location.href.includes("tabligh-staging.bale.ai") &&
  localStorage.getItem(LocalStorageKeys.Staging) === "true";
let baseURL = isProductionMode() ? "https://tablighapi.bale.ai" : "/api";
if (useStagingUrl) {
  baseURL = "https://tablighapiinternal.bale.ai";
}

const logger = WebLogger.getLogger("Api");

const axios = axios_.create({
  baseURL,
  timeout: 15_000,
});

axiosRetry(axios as any, { retries: 10, shouldResetTimeout: true });

axios.interceptors.response.use(
  (response) => {
    logger.debug(`response for ${response.config.url}`, response);
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      window.location.href = "/login";
      return Promise.resolve();
    }
    logger.error(error.response);
    return Promise.reject(error);
  }
);
axios.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem(LocalStorageKeys.AccessToken);
    if (config.headers) {
      config.headers.accessToken = String(accessToken);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default axios;

export type ApiResponse<ApiResponse, ErrorMessages> = Promise<{
  response?: ApiResponse;
  error?: ErrorMessages;
}>;

export const NetworkError = "-1";
export const ConnectionErrorToastId = "connection-error";
export type NetWorkError = typeof NetworkError;

export const getRequestError = <Errors extends number>(
  error: any
): Errors | undefined => {
  if (axios_.isAxiosError(error)) {
    const axiosError = error as AxiosError;
    const errorCode = axiosError.response?.data.error_code;
    if (errorCode) {
      return errorCode as Errors;
    }
  }
  toast.info(strings.connection_error, { toastId: ConnectionErrorToastId });
  return -1 as Errors;
  // throw Error(NetworkError);
};
